//removeIf(production)
import ClaroluzEventDispatch from '../../../../../infra/services/claroluz-event-dispatch';
import ClaroluzEvents from '../../../../../infra/critical/claroluz-events';
import ClaroluzQr from '../../../../../infra/services/claroluz-qr';
import ClaroluzTypeChange from '../uploader/claroluz-type-change';
import ClaroluzEventError from '../../../../../infra/services/claroluz-event-error';

var DSScanner: any = undefined;
//endRemoveIf(production)

class ClaroluzQrWorkerLegacy {
    private containerSelector: string;

    constructor(mainContainer: string, alternativeMode: string) {
        this.containerSelector = '.claroluz-qr';
        document.getElementById('status')!.classList.add('display-none');

        document.getElementById('status')!.addEventListener('DOMSubtreeModified', () => {
            if (document.getElementById('status')!.innerText.includes('NotFoundError')) {
                new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'desktop-version');
                document.querySelector('.steps-btn-container')?.classList.add('display-none');
                this.goToAlternativeMode();
                return;
            }

            if (document.getElementById('status')!.innerText.includes("Error (")) {
                new ClaroluzEventError('qr-code', 'ERROR_QR_CODE');
                new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'ERROR_QR_CODE');

                console.error(document.getElementById('status')!.innerText);
            }

            if (document.getElementById('status')!.innerText.includes("http")) {
                this.successEvent(document.getElementById('status')!.innerText);
            }
        });

        if (typeof DSScanner !== 'undefined') {
            this.clickEvent();
            this.errorEvent();
            this.resetEvent();
        } else {
            let scannerCheck = setInterval(() => {
                if (typeof DSScanner !== 'undefined') {
                    this.clickEvent();
                    this.errorEvent();
                    this.resetEvent();

                    clearInterval(scannerCheck);
                }
            }, 300);
        }
    }

    private clickEvent() {
        document.addEventListener('claroluz_send_qr', () => {
            new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'click');
            this.start();
        });
    }

    private errorEvent() {
        // DSScanner.addEventListener('onError', (error: any) => {
        //     if (appProperties().debug) {
        //         console.error(error);
        //     }

        // new ClaroluzEventError('qr-code', 'ERROR_QR_CODE');
        // new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'ERROR_QR_CODE');
        //     this.stop();
        // });
    }

    private resetEvent() {
        document.addEventListener('claroluz_reset_qr', () => {
            location.href = '#comenzar-ahorro';
            location.reload();
        });
    }

    private start() {
        document.querySelector(this.containerSelector)?.classList.add('scan');

        // @ts-ignore
        CreateScanner();
    }

    private stop() {
        this.goToAlternativeMode();
    }

    private successEvent(url: string) {
        for (let i = 0; i < url.length; i++) {
            if (url.substring(i, i + 1) === "®") {
                url = url.substring(0, i) + '&reg' + url.substring(i + 1, url.length);
            }
        }
        url = url.replace(/amp;/g, '');

        new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'qr-code-success');
        new ClaroluzEventDispatch('claroluz_submit', { type: 'qr-code', data: url });
    }

    private goToAlternativeMode() {
        new ClaroluzTypeChange('type-pdf', true);
    }
}

//removeIf(production)
export default ClaroluzQrWorkerLegacy;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error('Function not implemented.');
}
//endRemoveIf(production)